module.exports = __webpack_public_path__ + "teambot-security-static/img/logo.e06430eb.png";